"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
var types_1 = require("./types");
var useStyles = (0, styles_1.makeStyles)(function (theme) { return ({
    table: {
        borderRadius: function (props) {
            switch (props.variant) {
                case types_1.TableVariants.PRIMARY:
                    return '20px';
                case types_1.TableVariants.SECONDARY:
                    return '8px';
                default:
                    return '20px';
            }
        },
        padding: function (props) {
            return props.variant === types_1.TableVariants.SECONDARY ? theme.spacing(0, 1.5) : undefined;
        },
        '& .MuiTableCell-head': {
            boxShadow: function (props) {
                return props.variant === types_1.TableVariants.SECONDARY ? 'none !important' : undefined;
            },
            borderRight: function (props) {
                return props.variant === types_1.TableVariants.SECONDARY ? 'none !important' : undefined;
            },
            '&:first-child': {
                paddingLeft: function (props) {
                    return props.variant === types_1.TableVariants.SECONDARY ? 0 : undefined;
                },
            },
            '& h6': {
                fontSize: function (props) {
                    return props.variant === types_1.TableVariants.SECONDARY ? '10px' : undefined;
                },
                color: function (props) {
                    return props.variant === types_1.TableVariants.SECONDARY ? themes_1.materialColors.grey[400] : undefined;
                },
            },
        },
        '& .MuiTableCell-footer': {
            borderTop: function (props) {
                return props.variant === types_1.TableVariants.SECONDARY ? '1px solid #e0e0e0' : undefined;
            },
            color: function (props) {
                return props.variant === types_1.TableVariants.SECONDARY ? themes_1.materialColors.grey[400] : undefined;
            },
            padding: theme.spacing(1.75, 1.5),
            textTransform: 'uppercase',
            '&:first-child': {
                paddingLeft: function (props) {
                    return props.variant === types_1.TableVariants.SECONDARY ? 0 : theme.spacing(2.5);
                },
            },
            '& span': {
                fontSize: function (props) {
                    return props.variant === types_1.TableVariants.SECONDARY ? '10px' : undefined;
                },
                lineHeight: function (props) {
                    return props.variant === types_1.TableVariants.SECONDARY ? 'normal' : undefined;
                },
            },
        },
        '& .MuiTableCell-body': {
            border: function (props) {
                return props.variant === types_1.TableVariants.SECONDARY ? 'none' : undefined;
            },
            '&:first-child': {
                paddingLeft: function (props) {
                    return props.variant === types_1.TableVariants.SECONDARY ? 0 : undefined;
                },
            },
        },
    },
    tableEdit: {
        backgroundColor: themes_1.materialColors.yellow[50],
    },
}); });
exports.default = useStyles;
